var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.171 512.171",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m509.035 248.212-213.504-212.8c-3.051-3.029-7.595-3.904-11.627-2.304a10.67 10.67 0 0 0-6.571 9.856v117.333H10.667C4.779 160.298 0 165.076 0 170.964v170.667c0 5.888 4.779 10.667 10.667 10.667h266.667v116.885c0 4.309 2.603 8.192 6.592 9.856 1.323.555 2.709.811 4.075.811 2.773 0 5.504-1.088 7.552-3.115l213.504-213.419a10.655 10.655 0 0 0 3.115-7.552 10.682 10.682 0 0 0-3.137-7.552z",
    fill: "#f9ecc0",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.53d1436af619d544c56811e3e5b44149.svg";
export { ForwardRef as ReactComponent };